import Radios from './Radios.component';

export default Radios;
